import backend from './backend.json';
import localeData from './locale-data.json';
import unuseInPage from './unuse-in-page.json';

export default {
  ...localeData,
  ...backend,
  ...unuseInPage,
} as Record<string, string>;
